import React from 'react';
import sowee from "../images/sowee.png";
import edf from "../images/edf.png";
import engie from "../images/engie.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const logos = [sowee, edf, engie];

const Partenaires = () => {
    return (
        <Box sx={{ textAlign: 'center', mt: {xs: 4, md: 5} }}> {/* Marges réduites sur mobile */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                mb: { xs: 2, md: 4 },
                justifyContent: 'center'
            }}>
                <ArrowForwardIosIcon sx={{
                    mr: 1,
                    fontSize: { xs: 30, md: 50 }, // Taille réduite de l’icône sur mobile
                    color: '#3f72b5'
                }} />
                <Typography variant="h3" sx={{
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    color: '#3f72b5',
                    fontFamily: 'unset',
                    fontSize: { xs: '2rem', md: '2.5rem' } // Taille du texte adaptée
                }}>
                    Nos partenaires
                </Typography>
            </Box>

            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: { xs: 2, md: 6 },   // Espacement réduit entre les logos sur mobile
                flexWrap: 'wrap',         // Passe les logos à la ligne sur petits écrans
            }}>
                {logos.map((logo, index) => (
                    <Box
                        key={index}
                        component="img"
                        src={logo}
                        alt={`Partenaire ${index + 1}`}
                        sx={{
                            mx: { xs: 3, md: 15 },  // Marge horizontale réduite sur mobile
                            width: { xs: 120, md: 200 }, // Taille des logos ajustée pour mobile
                            height: 'auto'
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default Partenaires;
